export type LabelStyle = 'BESTSELLER' | 'BLACK_FRIDAY' | 'SEALER' | 'STANDARD';

// How the storefront draws a label on the product image (prod-box-new):
// "BESTSELLER" text gets a green corner badge, a name containing "Black
// Friday" a black bar with yellow text, "FREE SEALER" an orange bar, and
// anything else a yellow bar along the bottom.
export function labelStyle(title: string, label: string): LabelStyle {
  if (label === 'BESTSELLER') return 'BESTSELLER';
  if (title.includes('Black Friday')) return 'BLACK_FRIDAY';
  if (title.includes('FREE SEALER')) return 'SEALER';
  return 'STANDARD';
}

// List order: most products first, then by name.
export function labelOrder(a: { products: number; title: string }, b: { products: number; title: string }): number {
  return b.products - a.products || a.title.localeCompare(b.title);
}

export const LABEL_STYLE_NAMES: Record<LabelStyle, string> = {
  BESTSELLER: 'Green corner badge',
  BLACK_FRIDAY: 'Black Friday bar',
  SEALER: 'Orange bar',
  STANDARD: 'Yellow bar',
};
